import FroalaTypography from '@common/components/FroalaTypography';
import styled from '@emotion/styled';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

const StyledAccordion = styled(Accordion)`
  box-shadow: none;

  &:before {
    opacity: 1 !important;
  }
`;

const SourceResult = ({ pageData }:any) => {
  const sources = JSON.parse(pageData)
  return (
    <Box>
      {sources && sources.map((item: any, index: number) => (
        <StyledAccordion
          key={index}
          square
          disableGutters
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
            <Typography>{item.title}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <FroalaTypography dangerouslySetInnerHTML={{ __html: item.body }}/>
          </AccordionDetails>
        </StyledAccordion>
      ))}
    </Box>
  );
};

export default SourceResult;
